import { PDFDocument } from "pdf-lib";

export interface ISignaturePosition {
  x: number;
  y: number;
}

export class UtilDocumentSign {
  static dataUrlToBytes(dataUrl: string): Uint8Array {
    const base64 = dataUrl.split(",")[1];
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  static async overlaySignature(
    pdfBytes: ArrayBuffer,
    signatureDataUrl: string,
    position: ISignaturePosition,
  ): Promise<Uint8Array> {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pngBytes = this.dataUrlToBytes(signatureDataUrl);
    const pngImage = await pdfDoc.embedPng(pngBytes);

    const page = pdfDoc.getPages()[0];
    const { width } = page.getSize();

    const signatureWidth = width * 0.4;
    const signatureHeight =
      signatureWidth * (pngImage.height / pngImage.width);

    page.drawImage(pngImage, {
      x: position.x - signatureWidth / 2,
      y: position.y - signatureHeight / 2,
      width: signatureWidth,
      height: signatureHeight,
    });

    return await pdfDoc.save();
  }
}
